<template>
    <div class="games">

        <pageheader text="Spillhaller"/>

        <p>
            Her kan du se alle hallene du har tilgang til, trykk for å gå til spill.
        </p>



        <b-table striped hover :busy="isBusy" :items="games" :fields="fields" @row-clicked="sendToGame">

            <template v-slot:cell(value)="data">
                {{ data.value  }},-
            </template>

            <template v-slot:table-busy>
                <div class="text-center  my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Laster...</strong>
                </div>
            </template>

        </b-table>


        <div v-html="formContent">
        </div>

    </div>
</template>

<script>
// @ is an alias to /src


export default {
    name: 'Transactions',
    components: {

    },
    data() {
        return {
            games: [],
            isBusy: true,
            fields: [
                {
                    key:'name',
                    label:"Hallnavn"
                }
            ],
            formContent: ''
        }
    },
    mounted() {


        this.$api.get(`/users/${this.$store.getUser().card_id}/games/`)
        .then((response) => {

            this.games = response.data.data
            this.isBusy = false;

        })
        .catch((response) => {
            console.log(response);
        });


    },
    methods: {
        sendToGame(hall, index) {

            this.$api.get(`/users/${this.$store.getUser().card_id}/games/${hall.port}/`)
            .then((response) => {

                this.formContent = response.data

                setTimeout(function () {
                    let form = document.querySelector("form[name='form']");

                    form.submit();
                }.bind(this), 50)

            })
            .catch((response) => {
                console.log(response);
            });

        }
    }
}
</script>


<style lang="scss">

tbody tr {
    cursor: pointer;
}


</style>
